import React from 'react';
import BaseAvailableOffersOverlay from '@fingo/lib/features/factoring/components/overlays/BaseAvailableOffersOverlay';
import SvgIconWrapper from '@fingo/lib/components/icons/SvgIconWrapper';
import InformationIcon from '@fingo/lib/assets/icons/banco-de-chile/InformationIcon';

const AvailableOffersOverlay = () => (
  <BaseAvailableOffersOverlay
    title="No tienes facturas con oferta disponibles"
    overlayProps={{
      IconComponent: SvgIconWrapper,
      iconProps: { Icon: InformationIcon, sx: { width: 60 } },
    }}
    titleProps={{ variant: 'medium_2', color: 'primary.A400', fontWeight: 400 }}
    bodyProps={{ variant: 'small_2', fontWeight: 400, color: 'gray.A400' }}
  />
);

export default AvailableOffersOverlay;
